module.exports = __webpack_public_path__ + "static/media/mmx.4b959c87.jpg";